import AlertIcon from "assets/svg/alert-icon";
import CrossIcon from "assets/svg/cross-icon";
import ToastSuccessIcon from "assets/svg/toast-success-icon";
import toast from "react-hot-toast";

const renderCurrentToast = (type) => {
  switch (type) {
    case "success":
      return {
        icon: (
          <ToastSuccessIcon className="w-[18px] h-[18px] text-pure-white" />
        ),
        bgColor: "bg-secondary-forest-green",
      };
    case "error":
      return {
        icon: <AlertIcon className="w-[18px] h-[18px] text-pure-white" />,
        bgColor: "bg-secondary-forest-green",
      };
    default:
      return {
        icon: (
          <ToastSuccessIcon className="w-[18px] h-[18px] text-pure-white" />
        ),
        bgColor: "bg-secondary-forest-green",
      };
  }
};

export const customToast = (
  toastMessage,
  toastSubMessage,
  type,
  duration = 1000
) => {
  toast.dismiss("custom-toast");

  const { icon, bgColor } = renderCurrentToast(type);

  return toast.custom(
    (t) => {
      return (
        <div
          className={`${
            t.visible ? "animate-enter" : "animate-leave"
          } ${bgColor} text-pure-white rounded-[8px] p-[12px] shadow-toast-shadow relative overflow-hidden`}
        >
          <div className="flex items-center gap-[8px]">
            <div className="flex items-center gap-[8px]">
              {icon}
              <div className="flex flex-col gap-[2px] min-w-[250px]">
                {toastMessage && (
                  <p className="text-fixed-white dark:text-fixed-white-dk text-md font-medium">
                    {toastMessage}
                  </p>
                )}
                {toastSubMessage && (
                  <p className="text-xs text-gray-100 dark:text-gray-100">
                    {toastSubMessage}
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center justify-center">
              <button onClick={() => toast.remove(t.id)}>
                <CrossIcon className="w-[20px] h-[20px] text-black/15 dark:text-black/15" />
              </button>
            </div>
          </div>
        </div>
      );
    },
    {
      id: "custom-toast",
      duration: duration,
    }
  );
};
